import React from "react";
import { overviewRows, costRows, totalCosts } from "./siaKpisData";
import "./SiaKpisPage.scss";
import { usePageRefresh } from "../tools";

const PREFIX = "benchmarking.evaluations.sia-kpis";
const sectorCodes = overviewRows.filter(({ noga }) => noga !== null).map(({ noga }) => noga);

export default function SiaKpisPage({ translate, selectedTab, setSelectedTab }) {
  const SIA_KPIs_PAGE_TAB_INDEX = 2;
  usePageRefresh(selectedTab, SIA_KPIs_PAGE_TAB_INDEX, setSelectedTab);
  const label = (key) => translate(`${PREFIX}.${key}`);

  return (
    <div className="sia-kpis-page sia-padding-02-left sia-padding-02-right" id="sia-kpis-page">
      <section aria-labelledby="sia-kpis-overview-heading">
        <h3 id="sia-kpis-overview-heading" className="sia-kpis-page__section-title">
          <h3>{label("title")}</h3>
          {label("overview.title")}
        </h3>
        <div className="sia-kpis-page__scroll" role="region" aria-labelledby="sia-kpis-overview-heading" tabIndex={0}>
          <table className="sia-kpis-page__table sia-kpis-page__table--overview">
            <thead>
              <tr>
                <th scope="col">{label("noga")}</th>
                <th scope="col">{label("sector")}</th>
                <th scope="col" className="sia-kpis-page__numeric">
                  {label("survey-2014")}
                </th>
                <th scope="col" className="sia-kpis-page__numeric">
                  {label("survey-2025")}
                </th>
                <th scope="col" className="sia-kpis-page__numeric">
                  {label("difference")}
                </th>
              </tr>
            </thead>
            <tbody>
              {overviewRows.map(({ noga, survey2014, survey2025, difference }) => (
                <tr key={noga ?? "total"} className={noga === null ? "sia-kpis-page__total-row" : undefined}>
                  <td>{noga ?? label("total")}</td>
                  <th scope="row">{noga === null ? label("all-sectors") : label(`sector.${noga}`)}</th>
                  <td className="sia-kpis-page__numeric">{survey2014}</td>
                  <td className="sia-kpis-page__numeric">{survey2025}</td>
                  <td
                    className={`sia-kpis-page__numeric ${
                      difference.startsWith("+") ? "sia-kpis-page__increase" : difference.startsWith("-") ? "sia-kpis-page__decrease" : ""
                    }`}
                  >
                    {difference}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section aria-labelledby="sia-kpis-detail-heading">
        <h3 id="sia-kpis-detail-heading" className="sia-kpis-page__section-title">
          {label("details.title")}
        </h3>
        <div className="sia-kpis-page__scroll" role="region" aria-labelledby="sia-kpis-detail-heading" tabIndex={0}>
          <table className="sia-kpis-page__table sia-kpis-page__table--details">
            <thead>
              <tr>
                <th scope="col">{label("details.cost-item")}</th>
                {sectorCodes.map((noga) => (
                  <th key={noga} scope="col" className="sia-kpis-page__numeric">
                    <span className="sia-kpis-page__noga">{noga}</span>
                    <span className="sia-kpis-page__sector">{label(`column.${noga}`)}</span>
                  </th>
                ))}
                <th scope="col" className="sia-kpis-page__numeric sia-kpis-page__total-column">
                  <span className="sia-kpis-page__noga">{label("total")}</span>
                  <span className="sia-kpis-page__sector">{label("all-sectors")}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {costRows.map(({ key, values }) => (
                <tr key={key}>
                  <th scope="row">{label(`details.${key}`)}</th>
                  {values.map((value, index) => (
                    <td key={index} className={`sia-kpis-page__numeric ${index === sectorCodes.length ? "sia-kpis-page__total-column" : ""}`}>
                      {value}
                    </td>
                  ))}
                </tr>
              ))}
              <tr className="sia-kpis-page__total-row">
                <th scope="row">{label("details.total-costs")}</th>
                {totalCosts.map((value, index) => (
                  <td key={index} className={`sia-kpis-page__numeric ${index === sectorCodes.length ? "sia-kpis-page__total-column" : ""}`}>
                    {value}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <p className="sia-kpis-page__note">
        <strong>{label("note.title")}</strong> {label("note.text")}
      </p>
    </div>
  );
}
